// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1mzsq","productName":"Table_productName__1wJBn"};